import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
/* The kit's CSS rides with its components (<Shell> brings the house faces,
   the tokens, type and frame; each component its own sheet), so no kit
   stylesheet or font is imported here — a second import would ship it twice.
   The app's own CSS layers on top. */
import { ToastProvider } from '@ofself/shell'
import App from './App.jsx'
import './dictionary.css'

/* THE SEAT IS ROUND (owner call 2026-09-20: "undo, go back to round"). The
   kit's square and fill shapes were tried here the same night and set
   aside; they stay in the kit behind data-eco-seat-shape, off by default. */

// the kit's toasts: a move says what it did, with its Undo (App.jsx)
createRoot(document.getElementById('root')).render(<StrictMode><ToastProvider><App /></ToastProvider></StrictMode>)
